export default "__VITE_PUBLIC_ASSET__83654ee4__"